import { AxiosResponse } from "axios";
import http from "./httpService";
import { FileDto } from "../interfaces/FileDto";

const upload = async (file: File, onProgress: (event: any) => void): Promise<AxiosResponse<FileDto>> => {
  const apiEndpoint = "/file/upload";

  let formData = new FormData();
  formData.append("file", file);

  return await http.post<FileDto>(`${apiEndpoint}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: onProgress,
  });
};

const getFileMetadataById = async (fileId: number): Promise<AxiosResponse<FileDto>> => {
  const apiEndpoint = "/file";

  return await http.get<FileDto>(`${apiEndpoint}/${fileId}`);
};

export default {
  upload,
  getFileMetadataById,
};
